/*

	RestHandler mixin extends a component with some useful methods to perform axios requests
	
	Usage in target component (RestHandler needs to be included as mixin):
	
	this.restHandler__fetch({
		action : 'GET',	
		route : '/wp-json/wp/v1/pages',
		params : {
			postId : 341,
		},
		callback : (response) => {},
	})
	
	2019-06-14	bugfix: restBase wurde nicht richtig berechnet 
	2018-11-08	feature: just compare if the hostname from appConfig.js has indexOf, helps to work with local ip ranges like 192.168.
	2018-10-10	init

*/
import appConfig from '@/../appConfig.js'

export default {
	name: 'RestHandler',
	watch: {},
	data () {
		return {
			restHandler__debugLog : false,
		}
	},
	computed: {
		restBase(){	// returns baseUrl, e.g. "https://ies.local:8080"
			const currentHostname = location.hostname
			const environments = appConfig.environments
			const restHandler__debugLog = this.restHandler__debugLog
			let currentEnvironment = null
			let restBase = null

			if( restHandler__debugLog ) console.log('')
			if( restHandler__debugLog ) console.group('RestHandler.js')
			if( restHandler__debugLog ) console.log('currentHostname: ' + currentHostname)

			this._.forEach(environments, function(value, key){
				if( restHandler__debugLog ) console.log('	value.hostname: ' + value.hostname + ' > ' + currentHostname.indexOf( value.hostname ))				
				
				// 2019-06-14  currentEnvironment wird nur gesetzt wenn zuvor noch nicht
				if( currentHostname.indexOf( value.hostname ) > -1 && !currentEnvironment ){
					currentEnvironment = key
				}					
			})
			
			if( currentEnvironment ){
				restBase = environments[currentEnvironment].restBase.replace(/\/$/, "")
				
				if( restHandler__debugLog ) console.log('	currentEnvironment: ' + currentEnvironment)
				if( restHandler__debugLog ) console.log('	restBase: ' + restBase)								
			}
			
			if( restHandler__debugLog ) console.groupEnd('RestHandler.js')
			
			return restBase
		},		
	},
	methods: {
		restHandler__serializeParams ( obj, prefix ) {
			var str = [],
				p;
			for (p in obj) {
				if (obj.hasOwnProperty(p)) {
					var k = prefix ? prefix + "[" + p + "]" : p,
						v = obj[p];
					str.push((v !== null && typeof v === "object") ?
						this.restHandler__serializeParams(v, k) :
						encodeURIComponent(k) + "=" + encodeURIComponent(v));
				}
			}
			return str.join("&");
		},
		restHandler__fetch( args ) {
			const requestUrl = this.restBase + args.route + '?' + this.restHandler__serializeParams(args.params)
			const requestInCache = this._.find( this.$root.$data.RestHandlerCache, {requestUrl} );
			
			if( this.restHandler__debugLog ){
			
				console.log('%cRestHandler restHandler__fetch()', 'font-weight: bold; margin-top: 1em;')
				console.log('	args.action    : ' + args.action)
				console.log('	args.route     : ' + args.route)
				console.log('	args.params    : ' + this.restHandler__serializeParams(args.params))
				console.log('	restBase       : ' + this.restBase)
				console.log('	requestUrl     : ' + requestUrl )
				console.log('	requestInCache : ' + this._.isObject( requestInCache ) )
			
			}
			
			// there is a cached request, return this
			if( requestInCache ){			
				args.callback( requestInCache.response )			
			}
			// no cached request yet, perform the request
			else{
				this.axios
					.get(requestUrl)
					.then(response => { // handle success
							
						this.$root.$data.RestHandlerCache.push({
							requestUrl : requestUrl,
							response   : response,
						})
						
						args.callback( response )
					})
					.catch(function(error) { // handle error					
						console.log(error);
					})
					.then(function() { // always executed

					});	
			}
		},
		restHandler__fetchAllPaginatedPosts( args ) {	// walks the pagination 
			
			const self = this
			const debugLog = this.restHandler__debugLog			
			const perPage = args.params.perPage || 50
			
			let params = args.params
				params['paged'] = 1
				params['perPage'] = perPage
			let paginationLinks
			let stillToFetch
			let pages = {}
			let posts = []
			
			if(debugLog) console.log('%cRestHandler restHandler__fetchAll()', 'font-weight: bold; margin-top: 1em;')
			
			// 1. get pagination links 
			this.restHandler__fetch({
				action : args.action,				
				route : args.route,
				params : params,
				callback : (response) => {
					paginationLinks = response.data.info.paginationLinks
					stillToFetch	= paginationLinks.length
					
					fetchAllPages()
					
				}
			})
			
			// 2. walk all paginationLinks and get posts
			function fetchAllPages() {

				self._.forEach( paginationLinks, (paginationLink, i) => {
					
					self.restHandler__fetch({
						action : args.action,				
						route : args.route,
						params : {
							postType : args.params.postType,
							perPage : perPage,
							paged : i + 1,
						},
						callback : (response) => {
							stillToFetch = stillToFetch-1
							pages[response.data.info.currentPage] = response.data.result
							
							if( debugLog ) console.log('	fetched from   : ' + response.data.request.url + ' > posts: ' + response.data.result.length + ', open: ' + stillToFetch)
							
							if( !stillToFetch ){
								afterFetchAllPages()
							}							
						}
					})										
				})
				
			}
			
			// 3. merge all pages to posts-array
			function afterFetchAllPages(){	
				
				self._.forEach( paginationLinks, (paginationLink, i) => {
					const pagePosts = pages[i+1]
					
					self._.forEach( pagePosts, (pagePost, i) => {
						posts.push(pagePost)
					})
					
				})
				
				if(debugLog) console.log('	finished, all posts fetched, return posts ('+posts.length+')')
				
				args.callback( posts )
				
			}
		
		},
	},
	beforeCreate() {
		
		if( !this.$root.$data.RestHandlerCache ){
			
			if( this.restHandler__debugLog ){
				console.log('%cRestHandler beforeCreate()', 'font-weight: bold; margin-top: 1em;')
				console.log('	set: $root.$data.RestHandlerCache = []')			
			}
			
			this.$root.$data.RestHandlerCache = []
			
		}				
		
	},
	created() {},
	mounted() {},
}
